import { actionCreators as avatars } from "./avatars";
import { actionCreators as config } from "./config";
import { actionCreators as dialpad } from "./dialpad";
import { actionCreators as electronIntegration } from "./electronIntegration";
import { actionCreators as errors } from "./errors";
import { actionCreators as flux } from "./flux";
import { actionCreators as globalSearch } from "./globalSearch";
import { actionCreators as idle } from "./idle";
import { actionCreators as login } from "./login";
import { actionCreators as messageDropdown } from "./messageDropdown";
import { actionCreators as notifications } from "./notifications";
import { actionCreators as persist } from "./persist";
import { actionCreators as profile } from "./profile";
import { actionCreators as rooms } from "./rooms";
import { actionCreators as roster } from "./roster";
import { actionCreators as rosterSearch } from "./rosterSearch";
import { actionCreators as rosterSort } from "./rosterSort";
import { actionCreators as rosterSortMoratorium } from "./rosterSortMoratorium";
import { actionCreators as router } from "./router";
import { actionCreators as service } from "./service";
import { actionCreators as sipCall } from "./sipCall";
import { actionCreators as tracking } from "./tracking";

export { isOfAction, isOfActions } from "chalet-shared";

export const actionCreators = {
    ...errors,
    ...avatars,
    ...sipCall,
    ...service,
    ...config,
    ...dialpad,
    ...persist,
    ...notifications,
    ...rooms,
    ...login,
    ...router,
    ...rosterSearch,
    ...rosterSortMoratorium,
    ...rosterSort,
    ...idle,
    ...globalSearch,
    ...messageDropdown,
    ...roster,
    ...flux,
    ...tracking,
    ...profile,
    ...electronIntegration,
};

export type Action = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;
